/* eslint-disable tailwindcss/no-arbitrary-value --
   `text-[--text-secondary]` references the CSS variable directly, on purpose: the
   class `text-text/secondary` names a Tailwind theme key that the legacy modulab
   palette shadows with its own #42424a, and the colour QA asked for is the token's
   #424242 (CMS-1921 round 2). Documented in fe-services CLAUDE.md > Design tokens. */
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { formatCurrencyAmount } from '../../../utils/helpers/formatters';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';
import { TRANSLATIONS } from '../i18n';

interface LoanBasisNoteProps {
  loanAmount?: number;
  loanTenure?: number;
}

/**
 * States the loan a Personal Loan table's figures are calculated from
 * (CMS-1921 R6).
 *
 * System-generated from the module's own inputs, so it always describes the
 * same loan the cells were calculated from — a reader moving the page's loan
 * calculator changes neither. Renders nothing until both inputs are set: an
 * incomplete sentence is worse than none, and Strapi requires both in this
 * mode anyway.
 */
export const LoanBasisNote = ({
  loanAmount,
  loanTenure,
}: LoanBasisNoteProps) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);

  if (!loanAmount || !loanTenure) return null;

  const amount = formatCurrencyAmount(loanAmount, context.currencyDisplay);

  return (
    // Body copy, not table-cell type, and spaced off the table it describes
    // (CMS-1921 review items 4 and 5). The gap sits here rather than on the
    // table so it disappears together with the note.
    <p className="mb-spacing/gap/y-xs mhg-alpha-typography-body-2-relaxed text-[--text-secondary]">
      {staticText.loan_basis
        .replace('{amount}', amount)
        .replace('{tenure}', String(loanTenure))}
    </p>
  );
};
